var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"pa-6",attrs:{"rounded":"","flat":""}},[_c('entity',{attrs:{"id":_vm.$route.params.namespace + '/' + _vm.$route.params.identifier}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }